import { callAjaxIO } from 'Shared/ajax_io';

// eslint-disable-next-line no-var
export var RelatedWikiForm = {
   initialize(form) {
      const wikiRelatedInputDiv = document.querySelector('#wikiRelatedInputDiv');

      document.querySelectorAll('.wikiRelatedFormToggle').forEach(element => {
         element.addEventListener('click', ev => {
            ev.preventDefault();
            ev.stopPropagation();
            wikiRelatedInputDiv.classList.toggle('hidden');
            const headerLink = document.querySelector('#wikiRelatedHeaderLink');
            if (headerLink) {
               headerLink.classList.toggle('hidden');
            }
         });
      });

      form.addEventListener('submit', async ev => {
         ev.preventDefault();
         ev.stopPropagation();
         const msgDiv = form.querySelector('.statusError');

         const response = await callAjaxIO(
            'setRelatedWiki',
            Object.fromEntries(new FormData(form))
         );
         msgDiv.textContent = response.message;
         if (response.error) {
            form.querySelector('input').blur();
            msgDiv.style.display = 'block';
            msgDiv.style.opacity = '1';
            setTimeout(() => {
               msgDiv.style.display = 'none';
            }, 3000);
         } else {
            window.location.reload();
         }
      });
   },
};
